//toda vez que precisamos alterar uma informação passamos pelo reducer
//primeira coisa que criamos é uma interface para tipar os dados que teremos na store
//criar interface dentro do reducer

import { createReducer, on } from '@ngrx/store';
import { loadBankSuccess, saveBankSuccess } from './bank.actions';

export interface IBankState {
  lista: any[];
}

const initialState: IBankState = {
  lista: [],
};

export const bankReducer = createReducer(
  initialState,
  on(loadBankSuccess, (state, { lista }) => ({
    ...state,
    lista: [...lista],
  })),

  on(saveBankSuccess, (state, { bank }) => ({
    ...state,
    lista: [...state.lista, bank],
  }))
);
//colocar como parametro o bankReducer lá no app.module
//agora criamos o selector em um novo arquivo
